import type { OnInit } from '@angular/core';

import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Subject } from 'rxjs';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'web-create-block-modal',
    templateUrl: './create-block-modal.component.html',
    styleUrls: ['./create-block-modal.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslateModule],
})
export class CreateBlockModalComponent implements OnInit {
    private readonly bsModalRef = inject(BsModalRef);

    public type: 'header' | 'footer' = 'header';
    public onClose: Subject<boolean>;

    public ngOnInit(): void {
        this.onClose = new Subject();
    }

    public onConfirm(): void {
        this.onClose.next(true);
        this.bsModalRef.hide();
    }

    public onCancel(): void {
        this.onClose.next(false);
        this.bsModalRef.hide();
    }

    public onDismiss(): void {
        this.bsModalRef.hide();
    }

    public get titleText(): string {
        return this.type === 'header' ? 'shared_block_add_header' : 'shared_block_add_footer';
    }

    public get bodyText(): string {
        if (this.type === 'header') {
            return 'shared_block_add_header_description';
        }

        return 'shared_block_add_footer_description';
    }
}
